import SettingsIndexRoute from 'cio/pods/base/setup/settings/index/route';
import CampaignModel from 'cio/models/campaign';
import { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';

export default class IndexRoute extends SettingsIndexRoute {
  @service router!: RouterService;

  model(): CampaignModel {
    return this.modelFor('campaigns.campaign') as CampaignModel;
  }

  redirect(model: CampaignModel) {
    if (model.isDraft && model.isWebhookTriggered) {
      this.router.transitionTo('campaigns.campaign.setup.workflow.actions', {
        queryParams: {
          campaignId: model.id,
        },
      });
    }
  }
}
